// 该文件为自动生成，请不要直接修改该文件(直接修改该文件,送翻后修改会失效)
/* eslint-disable */
export default {
  "3259583117": "Notificar Cliente Para Redirecionamento",
  "1d484fee4a": "Departamento Financeiro, Departamento de Vendas, Gestão de Projetos, Dados de Negócios, Departamento de Produtos, Operações, Gestão de Pesquisa e Desenvolvimento, Planejamento de Versão, Atendimento ao Cliente, Administração, Compras, Gestão de Pós-venda",
  "a2c88dfb79": "Crie A Sua Primeira Equipa",
  "3cfdcc6086": "Departamento Financeiro, Departamento de Vendas, Gestão de Projetos/305, Gestão de Pessoal e Administração/306, Operações, Gestão de Pesquisa e Desenvolvimento, Planejamento de Versão, Gestão de Atendimento ao Cliente/403, Compras, Gestão de Pós-venda",
  "ac45ec2c05": "Falha Na Verificação De Login Da Conta",
  "9aef9b8ccd": "A Conta Que Está Atualmente Logada Está Anormal, Por Favor Faça Logout E Tente Novamente",
  "728dd00f22": "O Número De Telefone Informado Está Anormal, Por Favor Tente O Login Com Código De Verificação Via SMS",
  "30dbecd916": "As Informações Que Forneceu Contêm Palavras Sensíveis, Por Favor Modifique E Tente Novamente",
  "12ed508d8a": "Está A Operar Com Muita Frequência, Tente Novamente Mais Tarde",
  "952d4a7595": "O Estado De Login Da Conta Atual Está Anormal, Por Favor Faça Logout E Tente Novamente",
  "e64bfdeaa4": "Falha Na Verificação De Login, Por Favor Solicite O Código De Verificação SMS Novamente",
  "79008a65f1": "Este Número De Telefone Está Associado A Várias Empresas, Por Favor Faça Login Em Uma Empresa Diferente Ou Altere O Número De Telefone",
  "bf242eff42": "O Nome Da Empresa Já Existe",
  "4f0cdb8374": "Por Favor Insira O Número De Telefone Completo, Caso Utilize Um Número Estrangeiro, Altere Para Um Número Doméstico (86+)",
  "46e79ffeff": "Erro Ao Criar Empresa, Por Favor Contacte O Serviço De Apoio Oficial",
  "f3e18f0341": "Falha Na Validação De Parâmetros",
  "503fd1718d": "Falha No Envio Do Código De Verificação SMS",
  "24b3129f19": "Envio De SMS Muito Frequente, Por Favor Tente Novamente Mais Tarde",
  "1cde3e8245": "Código De Verificação Incorreto, Por Favor Insira Novamente",
  "4212ecc031": "Muitos Erros Na Verificação, Verificação Temporariamente Limitada, Por Favor Tente Novamente Mais Tarde",
  "735da9c347": "Erro Na Verificação De Nome Duplicado Da Empresa, Por Favor Contacte O Serviço De Apoio Oficial",
  "8731da9615": "Erro Na Validação De Nome Da Empresa, Por Favor Contacte O Serviço De Apoio Oficial",
  "62e89b3f16": "Concordo Com O Termo De Serviço",
  "c9b79027e5": "Enviar Código De Verificação",
  "84c1447b9d": "Copiado com sucesso",
  "fba4b0abd0": "Registro Do Host",
  "37f5a7cd41": "Valor TXT",
  "78b12427c9": "A Verificar...",
  "59d089837c": "Atualmente Não Podemos Verificar O Seu Domínio, Poderá Precisar De Esperar Um Pouco Para O Seu Provedor De Domínio Atualizar As Suas Informações. Se Após Algum Tempo Ainda Não Houver Resposta, Tente Verificar Novamente Ou Troque De Domínio.",
  "4a5b7383d1": "A verificar o domínio",
  "f24a492e40": "Os registos de verificação, pode fechar esta página e voltar mais tarde para verificar.",
  "c697ca5f1a": "Bem-vindo ao Enterprise Edition",
  "ebb01b1740": "seguinte",
  "30109bf753": "A sua empresa tem um domínio?",
  "2b3e485b47": "Tenho um domínio empresarial",
  "1a7f5eae44": "Não tenho um domínio empresarial.",
  "bde15d6d84": "Precisa de um domínio (por exemplo, example.com) para criar uma conta de empresa.",
  "07ffb22c90": "Desculpe, precisa de um domínio para criar uma conta empresarial para a sua empresa.",
  "de23836563": "Por favor insira o domínio para criar uma conta empresarial",
  "287c07944a": "Verifique o seu domínio",
  "3ea2d528d5": "Conclua os seguintes passos para comprovar que é o proprietário do <b>{domain}</b> e impedir que qualquer outra pessoa use este domínio para registar uma conta empresarial.",
  "082b18ce56": "a. Abra o site do provedor de hospedagem de domínio em uma <b>nova aba</b> e depois <b>inicie sessão</b> na sua conta;",
  "4f7e0841a9": "b. No site do provedor de hospedagem de domínios, vá para a <b>seção de registos DNS</b>. No site do seu provedor de hospedagem de domínios, o nome da seção de registos DNS pode variar, podendo ser exibido como <b>Gestão de DNS, Gestão de Servidor de Nomes, Painel de Controle ou Configurações Avançadas</b>.",
  "6365ad6e3a": "Em seguida, <b>volte aqui</b> e clique em \"Próximo\" para adicionar o registo de verificação.",
  "8528892080": "Adicionar Registo de Validação",
  "7a225304f8": "a. Na página de DNS, role até à secção <b>TXT</b> e, em seguida, clique no botão correspondente para adicionar um registo;",
  "b3cb7d947c": "b. Copie e cole <b>todos os valores abaixo</b> no <b>formulário TXT</b> do site do serviço de hospedagem do domínio;",
  "47213583bf": "c. <b>Save</b> o registo no site do serviço de alojamento de domínios, <br> depois <b>volte aqui</b> e clique em \"Verificar Domínio\" abaixo",
  "21486a57cf": "Atenção: no campo Nome/Host/Alias, pode introduzir \"@\" ou deixá-lo em branco. O provedor de serviço de nome de domínio pode também pedir para introduzir o nome de domínio (seu-dominio.com) nesse campo. Pode determinar como preencher este campo com base em outros registros DNS. No campo Tempo de Vida (TTL), digite \"86400\" ou mantenha o valor padrão.",
  "f1b8edab9c": "Alterar Domínio",
  "7c6fc663a8": "Certificar Domínio",
  "b6aee9dc0d": "Verificação de Domínio Bem-Sucedida",
  "dd4cc429ea": "Provou ser o proprietário de",
  "450f5c9230": "e impede qualquer outra pessoa de usar este domínio para registrar uma conta corporativa.",
  "71cbcba755": "Clique em \"Próximo Passo\" para concluir a criação da conta corporativa.",
  "f4084f4870": "Por favor, configure sua conta de login",
  "fe3138baec": "Concluir Criação",
  "0315cddedb": "Criação de Empresa Bem-Sucedida",
  "91454a7f34": "Agora vá para o painel de gestão para criar contas corporativas para seus membros da empresa.",
  "366304cde7": "1. Terminará automaticamente a sessão atual do WPS Account.",
  "8a9f2a8422": "2. Deve usar a conta empresarial {account}@{domain} para entrar no painel de administração.",
  "43e265e998": "Ir para o painel de gestão",
  "9240efaaf0": "Mensagem enviada",
  "e424bb9a6d": "Introduza",
  "d44d581706": "Nome da Empresa",
  "aa8679f406": "4-30 caracteres",
  "581bdb1f98": "Não pode conter símbolos especiais como \\/:*?\"<>|{}",
  "c13cabb67a": "e-mail:",
  "2b9b429e46": "Seu Email",
  "5ed834a7df": "Por favor, insira seu email",
  "acfd1f02ed": "Por favor, insira um email válido",
  "31c7c92cca": "Até 80 caracteres",
  "3f27cf84b3": "Por favor, insira o código de verificação",
  "a0ae1f3ec4": "Código de verificação incorreto",
  "e5589c5e74": "Seu Nome",
  "69d7bd63f6": "Permitido somente caracteres chineses, letras e números",
  "91f008d258": "Máximo de 8 caracteres",
  "6ea6c9b39b": "Telefone",
  "161042c5b7": "Por favor, insira o telefone de contato",
  "e6b8eab1cd": "Por favor, insira um telefone de contato, 11 dígitos",
  "3fd5fbb3cc": "Por favor, insira o seu domínio",
  "cb5346ba8e": "Por favor, insira um domínio empresarial válido, 4-30 caracteres",
  "27928eb7a4": "Conta",
  "8e19bd444d": "Por favor, insira o nome da conta de login",
  "7bbbf479dc": "4-20 caracteres, somente números, letras ou sublinhado",
  "3d84cae479": "Por favor, insira um nome de conta válido; o primeiro caractere deve ser uma letra ou número",
  "c0d5ece1a7": "Palavra-passe",
  "f444036fa8": "Introduzir palavra-passe",
  "b03218d72b": "A senha deve ter de 12 a 16 caracteres, incluindo letras maiúsculas e minúsculas, números ou três tipos de combinações",
  "b4ab05df50": "*Já há alguém na sua instituição usando seu domínio para conta empresarial. Por favor, contate o suporte ao cliente (400-677-5005) para comprovar a propriedade do domínio",
  "c58876008f": "Falha ao copiar, por favor, tente novamente",
  "86f73420de": "Link de Convite",
  "a58861962c": "Desculpe, seu navegador atual não suporta o download do código QR",
  "228db07f78": "Departamento Financeiro, Departamento de Vendas, Gestão de Projetos, Dados de Negócios, Departamento de Produtos, Departamento de Operações, Gestão de Desenvolvimento, Planeamento de Versões, Departamento de Atendimento ao Cliente, Departamento Administrativo, Departamento de Compras, Gestão de Pós-Venda",
  "93896d7e98": "Crie uma equipe e comece a colaborar com colegas",
  "e8f66fb75c": "Departamento Financeiro, Departamento de Vendas, Gestão de Projetos/305, Recursos Humanos e Administração/306, Departamento de Operações, Gestão de Desenvolvimento, Planeamento de Versões, Gestão de Atendimento ao Cliente/403, Departamento de Compras, Gestão de Pós-Venda",
  "831b73da9b": "O nome não pode conter caracteres ilegais e símbolos especiais /\\;:*?\"<>|%&",
  "51ab33b3ee": "Parâmetros incorretos",
  "a297f9e951": "Nome da empresa duplicado",
  "04d60ed5f5": "Não é permitido usar palavras proibidas",
  "2ff7bef083": "Erro no formato do domínio",
  "41e1ba2165": "Falha ao validar informações TXT do domínio",
  "50f348caa9": "Conta duplicada",
  "9d4c950d65": "Este nome já está registrado",
  "38cf19ed95": "Este nome de instituição já existe",
  "4b426e7c9c": "Nome da Instituição",
  "298f880e18": "Já existe, sugerimos adicionar mais informações:",
  "1e67dd20b3": "Recuperar Nome da Instituição",
  "517107cb04": "Usar outro nome",
  "5667081882": "Criar com este nome",
  "e306a979a6": "Preenchimento Rápido:",
  "f583db96e0": "*Se o nome da instituição estiver ocupado, você pode",
  "9767148e34": "Por favor, insira o nome de uma empresa ou organização, entre 4 e 100 caracteres",
  "e0e0ec159f": "Nome da Instituição",
  "5b13d254c0": "Este nome de empresa já existe",
  "92027671ec": "Nome da Empresa",
  "36d482a7fb": "Recuperar Nome da Empresa",
  "79058a7577": "*Se o nome da empresa estiver ocupado, você pode",
  "c96dd48dba": "Nome da Empresa",
  "842efad336": "*Se for funcionário da empresa,",
  "860f9bd77b": "Suporte ao Cliente",
  "5a7ed18daf": "Junte-se à empresa",
  "ab470e9ace": "Informações de contato reservadas",
  "0a7e0e48a7": "Nome da empresa solicitada:",
  "a8dc318dcc": "Por favor, verifique as informações de contato que você preencheu. Em breve, o suporte da plataforma entrará em contato por telefone",
  "6ea1f4d7f5": "Enviar Documentos",
  "d439e39f43": "Recebemos seus documentos",
  "884653426b": "O atendimento ao cliente ligará para você dentro de 24 horas, por favor, esteja atento para atender!",
  "2361cb14bf": "Escaneie o código QR do WeChat para adicionar o serviço de atendimento online e acompanhar o progresso",
  "50f45d0031": "Falha ao guardar",
  "fc856d0fd2": "Super Administrador",
  "e16c0676d2": "Administradores",
  "b1d2ddd126": "Membro Comum",
  "9d322cc08d": "Nomes de organizações não podem conter símbolos especiais \\ / : * ? \" < > | {}",
  "b583ba7363": "Nomes de empresas não podem conter símbolos especiais \\ / : * ? \" < > | {}",
  "1d118a9bad": "O nome da organização deve ter pelo menos 4 caracteres, insira um nome de organização de 4 a 100 caracteres",
  "441b45b1f5": "O nome da empresa deve ter pelo menos 4 caracteres, insira um nome de empresa de 4 a 100 caracteres",
  "97457cb1f0": "O nome da organização excede 100 caracteres, insira um nome de organização de 4 a 100 caracteres",
  "8ce00d3b92": "O nome da empresa excede 100 caracteres, insira um nome de empresa de 4 a 100 caracteres",
  "a72778d3de": "O nome deve ter pelo menos 2 caracteres, insira um nome de 2 a 10 caracteres",
  "79c17db5de": "O nome excede 10 caracteres, insira um nome de 2 a 10 caracteres",
  "482a118202": "O nome só suporta caracteres chineses, números, inglês e ·",
  "9a9be18941": "Por favor, marque",
  "e6b7c4aa66": "Acordo de Serviço Online",
  "595023d905": "Criar Organização",
  "ba8c2df551": "Ocultar localizações comuns",
  "d284384975": "Acordo de Serviço Online",
  "5c266d5a84": "Política de Privacidade",
  "fcb92dbcf6": "Acordo de Serviço de Escritório na Nuvem",
  "2ae7a8a3f7": "Obrigado por escolher o serviço de nuvem WPS 365. A seguir, é apresentada uma introdução ao acordo legal entre você e/ou a organização que representa e a Kingsoft Office sobre o registro, assinatura e uso deste serviço.",
  "d30a6983bd": "Por favor, leia {0} | {1} | {2} e clique em \"Concordo\" para aceitar o conteúdo do acordo e receber nossos serviços.",
  "263e306ede": "Li e concordo com {0} | {1} | {2}",
  "440129c0f1": "Por favor, insira {0}",
  "8ab916983d": "Nome da Empresa",
  "b01d68543b": "Seu Nome",
  "684b30d4e9": "Seu Número de Telefone",
  "a48427e8e2": "Para estabelecer uma plataforma de trabalho pertencente à sua empresa",
  "3a81b0f1fc": "Facilita que colegas possam encontrar você no sistema para colaboração no trabalho",
  "52bc539b6e": "Confirmar Criação",
  "b2fe245e19": "Criar Empresa/Equipe: Partilha de Ficheiros e Colaboração",
  "893282d3f7": "Por favor, complete as informações da empresa:",
  "cc997bf6aa": "Confirmar",
  "50fdde51ac": "{0}, {1}~{2} dígitos",
  "a19cc5ec18": "{0}, não pode conter símbolos especiais \\u005C/:*?\"<>|{}",
  "26857f28f9": "{0}, apenas permite entrada de caracteres chineses, letras e números",
  "f4080b1431": "{0}, máximo de {1} caracteres",
  "88e59b2d58": "{0}, 11 dígitos",
  "91d6d4e105": "Por favor, insira o código de verificação",
  "bec71bde96": "Código de verificação incorreto",
  "e20ff8ee19": "{0} é obrigatório",
  "8dc09d10d7": "Não encontrei dwId",
  "a03766ce6c": "Escola",
  "03542addfe": "empresa",
  "adb8a815d1": "Número de telefone vinculado a {0} atingiu o limite",
  "97a6b66f1d": "Número de telefone atual já vinculado a {0}",
  "665e465487": "Não foi possível criar {0}. O número de telemóvel atual \"<strong>{1}</strong>\" atingiu o limite máximo de {0} associados (máximo 5 {2}). Pode aceder aos {3} já associados abaixo:",
  "a85b1367ca": "Número de telefone atual \"{0}\" já vinculado a {1}, pode escolher logar com os {2} existentes ou criar novo {3}:",
  "bf992ce17b": "Usar outro número de telefone para criar {0}",
  "395ea04444": "Criar novo {0}",
  "4ce3bb86b3": "Número de {0} para aderir ultrapassou o limite",
  "df88c4b7a5": "Número de telefone atual \"{0}\" já atingiu o limite de vinculação de {1}",
  "78f7dd59ca": "Número de telefone atual \"{0}\" está vinculado aos seguintes {1}, pode alternar facilmente",
  "8db491a3f8": "Continuar a criar novo {0}",
  "83f6d9e1e4": "Tentar novamente",
  "1dc5f11612": "ou",
  "217d76f53e": "Comentários",
  "b69a6ea62a": "Por favor, mantenha o botão esquerdo do mouse pressionado e raspe para revelar dois escudos",
  "3a31f64800": "Parabéns, você raspou com sucesso um escudo<br/>Continue com o próximo passo",
  "6a81fcee96": "A carregar",
  "e97877a65d": "Oh, o escudo desapareceu<br/>Por favor",
  "8d85456145": "Esperei muito tempo<br/>Por favor",
  "77ad847b95": "Problemas de rede<br/>Por favor",
  "dbd1ae3a34": "Você foi rápido demais<br/>Por favor",
  "bd8e05cd53": "Clique no botão para iniciar a verificação inteligente",
  "63d2a8a722": "Verificação bem-sucedida",
  "73141928ad": "Verificação falhou, por favor clique no botão para atualizar",
  "04856c5c8a": "Detecção inteligente em andamento",
  "52cd9bd26d": "Sua operação não está autorizada",
  "fd157e8ea8": "Guiar para criação",
  "c6225c5b2b": "Bem-vindo à versão empresarial",
  "e33423fb1e": "Criação bem-sucedida",
  "7b0c035999": "Página de sucesso de criação empresarial do WPS Office",
  "85db8faae0": "Instruções de uso da versão empresarial",
  "20591b9b44": "Recuperar nome da empresa",
  "b023d76dc2": "Guia de upload de membro",
  "e2f454e095": "Empresa de {0}",
  "df466f942b": "Divisão",
  "26a7b797c4": "Centro de sub-região",
  "5fc82b360b": "Plataforma de serviços de escritório integrada, tornando seu trabalho mais eficiente",
  "f2e736d52e": "Bem-vindo à versão empresarial",
  "becc41a35b": "Nome da empresa",
  "74685cdc58": "Por favor, insira o nome da empresa ou organização, entre 4-100 caracteres",
  "07b55b1907": "Tamanho da Empresa",
  "77b2f763ad": "Selecione o Tamanho da sua Empresa",
  "49d2509109": "Menos de 5 Pessoas",
  "8db2c9b74a": "6-20 Pessoas",
  "a9fb0cf14a": "21-50 Pessoas",
  "0fed41f8d3": "51-100 Pessoas",
  "fb33f25a04": "101-200 Pessoas",
  "3e3ff0f52e": "201-500 Pessoas",
  "cd8b51f634": "501-2000 Pessoas",
  "0662fa6eec": "Mais de 2000 Pessoas",
  "69334dba1a": "Necessidades da Empresa",
  "79994e749c": "(Vamos recomendar as melhores práticas do setor para a empresa)",
  "840a017f38": "Selecione o Problema que Mais Deseja Resolver",
  "f045b05c73": "Insira suas Necessidades ao Criar a Empresa",
  "d8efb0b36d": "Mais",
  "adcb8fbb0c": "Número de Telefone Usual",
  "eb1c73e2ca": "Insira Seu Número de Telefone de 11 Dígitos Usual",
  "7f276e7dfa": "Criar Gratuitamente",
  "c391b3eec1": "Falha ao Enviar SMS",
  "54f4cb8fa7": "SMS Enviado",
  "231eb1fa1e": "Utilizador empresarial {0}",
  "272b0f9d32": "Utilizador da versão Enterprise",
  "b209a67331": "Falha ao Criar Empresa. Por favor, atualize a página.",
  "acb08d0cc9": "Terceiro Passo para Criar Empresa",
  "83db361f51": "Após a Criação, Disparar a Lógica de Redirecionamento",
  "1e930326e3": "handleStep para ir para o próximo passo",
  "184df5c725": "saveForm falhou",
  "736eab3023": "Enviar Validação",
  "2db62dc13c": "Falha na Validação",
  "54fb0afaea": "Sucesso na Validação",
  "d39cff3fcf": "Pular Salvar Extremamente Só Descobrir Que Precisa de Código de Verificação",
  "305b777ae5": "Falha ao Verificar Nome, Abrir Popup 'Nome da Empresa Ocupado' e Salvar Nome",
  "e57b6686b2": "Verificar se a entidade de autenticação já foi autenticada, abrir a janela pop-up de alerta de proteção de autenticação e armazenar as informações do tema de autenticação correspondente",
  "f7c86f496d": "Nome duplicado na criação || Código de verificação expirado Se existir falha, bloquear a execução",
  "cb37db4fd4": "Falha no handleSubmit",
  "243a569fc4": "Este Nome Já Está Registrado. Por Favor, Use Outro Nome",
  "196851a3d9": "Utilizador empresarial {0}",
  "0c3a3595ff": "Utilizador da versão Enterprise",
  "a33b41e0f2": "Falha ao Criar Empresa. Por favor, atualize a página.",
  "fcce6a7156": "Criação Bem-Sucedida",
  "5ec6da58a6": "Notificar Cliente",
  "259c9dfa4e": "Lógica de Versão Profissional",
  "864156930f": "Lógica VBA",
  "7824efd172": "AirPage Móvel",
  "52b6cfaaaf": "Client WPS",
  "c7c51beea9": "Versão Educacional",
  "8d054d4986": "Endpoint padrão",
  "b597e18fb1": "isWps365PcClient e tem openurl",
  "b0c13de2a0": "isWps365PcClient ou Não é Client, Tem openurl",
  "7d0f2ce18c": "isWps365PcClient ou Não é Client, Tem openurl Sucesso Callback",
  "e2c5a07df6": "não client não openurl",
  "29e0414d1f": "não client não openurl retorno",
  "60861f7d2a": "AutoChange deixado para o lado comercial alternar",
  "7c83140d90": "criação em estado de visitante, não é necessário alterar a conta através do sdk (sdk não suporta visitantes), o código já foi alterado com sucesso através da interface",
  "3379b09e59": "tem openurl e usa href para alternar",
  "586ff04c22": "pular sozinho",
  "b6c91f218b": "useSuccessSkip falhou",
  "47d2f3ba66": "Mais",
  "57551f86ce": "Métodos de redirecionamento disparados de acordo com utm_source",
  "64fe3758e2": "Sua ação não está autorizada",
  "4da3e1262f": "Criado com sucesso, começando sua jornada de escritório empresarial",
  "c38dfb8c6c": "Crie seu primeiro time",
  "38dddb483b": "Entrar na empresa",
  "614d9c91eb": "Convide membros a entrar",
  "97f1eca0aa": "Entrar na empresa",
  "13a4939e90": "Convite para entrar na empresa",
  "a319e4ae0a": "Convide colegas a entrar",
  "12e4da6bba": "Convide colegas imediatamente",
  "bd885380f6": "Falha ao obter o link de convite",
  "5e626c4063": "Mensagem já enviada",
  "3dc09e7cfd": "O número de nomes empresariais solicitados para recuperação atingiu o limite",
  "48318f41f9": "Convide membros a entrar",
  "45441baac4": "Convido você a entrar em {0} para colaborar",
  "e5847fbd67": "Copiar link, convidar membros",
  "23101dd40a": "Estamos personalizando uma solução para você",
  "71bb7e54a8": "Gestão de projetos",
  "aff37c79cc": "Experimente o plano selecionado",
  "a97b174258": "Convidar mais <color: red>2</> colegas para se juntar, ganhar gratuitamente os seguintes benefícios empresariais",
  "253855849f": "Compartilhe o link de convite no grupo de trabalho e convide colegas",
  "57b0a2a63f": "Copiar link, convidar colegas",
  "71c0a37ee1": "Entrar na empresa",
  "f848c60e0e": "Convide mais <color:red>2</> colegas para obter gratuitamente os seguintes benefícios empresariais",
  "664e32b4fe": "Página de convite Entrar na empresa",
  "872f14403a": "Convide colegas a entrar",
  "1880e7deb9": "Convide colegas imediatamente",
  "cc2a9aaf82": "Criado com sucesso",
  "02a13e2583": "Convidar mais <color: red>2</> colegas para se juntar, ganhar gratuitamente os seguintes benefícios empresariais",
  "5d3593cdce": "Falha ao obter informações da equipe",
  "c025113ea1": "Falha ao obter o link de convite",
  "b83bc1e485": "Link de convite",
  "0996ced9f6": "Desculpe, seu navegador atual não suporta baixar este código QR",
  "1e88451e31": "Link de convite copiado",
  "bb969cabcd": "Falha na cópia, por favor tente novamente",
  "15e1f79c7a": "Solicitar entrada na empresa",
  "59c22b4ef8": "Recebeu um link de convite",
  "0f0b392e60": "Crie o Seu Primeiro Equipao",
  "0437d07c43": "Nome da Empresa",
  "41800c7bf1": "Introduza o Nome do Criador",
  "1ec5999511": "O Nome do Criador Deve Ter no Máximo 8 Caracteres",
  "02da35b4e4": "O Nome do Criador Deve Conter Apenas Caracteres Chineses, Letras e Números",
  "184e9f6616": "Introduza o Número de Telefone",
  "9b587898ba": "Introduza um Número de Telefone Válido",
  "e68c164a02": "Introduza o Seu Email",
  "0b1de22df7": "Introduza um Email Válido",
  "61026181ab": "Licença Comercial Obrigatória",
  "c3847e604e": "O Tamanho do Arquivo Excede 10M, Por Favor Selecione Novamente",
  "49450f4ec7": "Formulário de Apelação de Nome Necessário",
  "39c3b8fa1d": "Submissão Falhou",
  "3ea44d7963": "Upload Bem-Sucedido",
  "5b1aa3c2c4": "Upload Falhou",
  "7e7f81eaa3": "Upload Falhou, Arquivo Maior que 10m",
  "2ff1913de1": "Falha ao carregar, o ficheiro deve ser .jpg, .jpeg, .png, .bmp, .pdf",
  "7951a879f2": "Licença Comercial Obrigatória",
  "66bda65057": "O Tamanho do Arquivo Excede 10M, Por Favor Selecione Novamente",
  "8f2305a83d": "Formulário de Apelação de Nome Necessário",
  "55ff0c8c6e": "Submissão Falhou",
  "8dad6d950d": "Falha ao Obter Informações de Convite",
  "a5f0ac3a9a": "Criação Bem-Sucedida",
  "4f1d069770": "Parâmetro utm de Acesso da Página de Convite são {0} e nome {1}",
  "f9578cfe6d": "Parâmetro utm de Acesso de Guia em Duas Etapas são {0} e nome {1}",
  "e10d028405": "Guia em Duas Etapas Pcoffice Criado",
  "8e22e4fcc4": "Link de Convite Copiado",
  "3f327f9f37": "Falha ao Copiar, Por Favor Tente Novamente",
  "bd1aecb265": "Cancelar",
  "b6abf9b19a": "Concordo",
  "e910d9cc0f": "Cancelar",
  "37ab25522d": "Concordo",
  "196b3eb9cf": "Junte-se via Código QR",
  "2b81c52e20": "Baixar Imagem",
  "62152fd9f3": "Convite por Link",
  "e0a3725651": "Desculpe, Seu Navegador Atual Não Suporta o Download Deste Código QR",
  "8b7883b2c7": "Junte-se via Código QR",
  "9e9a659ed5": "Baixar Imagem",
  "0d55065a9a": "Convite por Link",
  "487cf6a106": "Desculpe, Seu Navegador Atual Não Suporta o Download Deste Código QR",
  "78fd005d1f": "Introduza o Número de Telefone",
  "f909563857": "Usar Este Número para Criar",
  "a26a19f139": "Cancelar Criação",
  "cc004ac9ee": "Número de Telefone",
  "4df8c3c588": "Introduza Outro Número de Telefone para Criar Escola",
  "3151cabb3d": "Introduza Outro Número de Telefone para Criar Empresa",
  "56098a71eb": "Clique em Verificação Inteligente, Envie o Código",
  "e96ec218e4": "Introduza o Código SMS",
  "ce619a0225": "Código SMS Enviado Para",
  "0e9863aaeb": "Código Inválido, Por Favor Insira Novamente",
  "32dc8629e1": "Reenviar em Segundos",
  "e4eda9add5": "Voltar a Enviar",
  "b007977564": "Falha ao Obter Informações de Aprovação",
  "d8852ffc9c": "Acesso Não-Administrador",
  "8a733a2574": "Acesso Móvel",
  "9e8c152c4f": "Acessar no PC",
  "2265a55e93": "Aceitar o Acordo de Serviço",
  "80dabe5aa3": "Criar Guia",
  "7deee8bf5a": "Guia em Duas Etapas docsWeb  criado",
  "69eb501ecb": "Sua apelação expirou, acesso negado",
  "aa1d9d98ad": "Permissão insuficiente, acesso negado",
  "fdf2fe129e": "Criar Organização",
  "7f0ca0df6b": "Ocultar localizações comuns",
  "cc6ac2a93c": "Base montada em duas etapas",
  "5d6c570bf0": "Antes de descarregar em duas etapas",
  "a4eb8a192d": "Equipe que todos estão criando",
  "4912e16a9d": "Nome da empresa recuperado",
  "41c4e87ef2": "Você pode clicar no link",
  "5e630930c0": "Recriar Empresa",
  "436a563524": "Se você já criou uma empresa, pode seguir",
  "0b6e7cbe7f": "'Como modificar o nome da empresa'",
  "cb7bce0775": "Tutorial para modificar o nome da empresa",
  "3feadd3040": "Versão atual muito baixa, não é possível usar a empresa",
  "3cf23de936": "Sua versão do software é muito baixa, o recurso da empresa não está disponível. Por favor, vá para a loja de aplicativos para atualizar a versão do software!",
  "a1c5d5d202": "Ok",
  "e50183bd00": "WPS Cloud",
  "e5031ab679": "Segurança, Sincronização, Colaboração",
  "c870026dfc": "Início de sessão no Wechat",
  "e7647cd875": "Início de sessão na conta do WPS",
  "07b380074b": "Início de sessão no QQ",
  "67921724dd": "Outros métodos",
  "254da8a9f5": "Número máximo de adesões/criações de empresas atingido",
  "3648e4811b": "Entrar em Docs",
  "dcd102b346": "Criar Equipe Personalizada",
  "8b9b258cbf": "Digite o nome da equipe aqui",
  "19bb6e0ded": "Membros WPS desfrutam",
  "2d9fe8d938": "Benefícios de escritório, ajudando a resolver problemas de documentos do dia a dia, venha experimentar agora!",
  "e8c1caa649": "Carregar do Local",
  "03641083a3": "Mover de 'Documentos Pessoais'",
  "eecd3ab9b5": "Próxima vez",
  "13b447b3a8": "Substituir",
  "3c2fc507fc": "Versão atual muito baixa, não é possível usar a empresa",
  "c3615d8134": "Sua versão do software é muito baixa, o recurso da empresa não está disponível. Por favor, vá ao site oficial para atualizar a versão do software!",
  "644a36e05b": "Atualizar",
  "d435105f21": "Número máximo de adesões/criações de empresas atingido",
  "73a286ceb0": "Entrar em Docs",
  "c2cec645c0": "Cancelar",
  "b5f5b83c0f": "Concordo",
  "76ec352da5": "Convidar colega com código QR",
  "6a509e4487": "Baixar QR Code",
  "940cc4a546": "Não é possível criar empresa",
  "78b2a62ea5": "Entrar em uma empresa existente ou criar uma nova",
  "3a6da7f6f9": "O número de empresas vinculadas ao número de telefone atual atingiu o limite (máximo de 5 empresas)",
  "93bab52870": "O número de telefone atual já está vinculado a uma empresa, você pode escolher uma empresa existente para entrar:",
  "ce6e0adaf2": "Você pode escolher entrar em uma das empresas vinculadas abaixo:",
  "1ce200a92b": "Selecionar",
  "bb91ef2999": "Criar nova empresa",
  "024e4a91e5": "Nome da empresa já registrado",
  "eb089a23a0": "Este nome de empresa já está registrado:",
  "7646558701": "Administrador:",
  "1d9c02bd33": "Data de Registro:",
  "919fc7805f": "Recomenda-se tentar localizar e contactar o colega acima mencionado.",
  "0ca71a9344": "Você também pode usar temporariamente outro nome para criar a empresa (pode ser alterado mais tarde), e depois apresentar uma apelação.",
  "e83a244e90": "Clique para saber como reclamar.",
  "d22bedfb21": "OK",
  "907b78b6e5": "Insira o nome do grupo de trabalho ou da equipa",
  "7195b0ac1e": "As equipas que pode querer criar",
  "60ed4f915e": "seguinte",
  "f5ba8dfb7b": "Saltar Guião",
  "5c44a3ef68": "Máximo de 100 caracteres",
  "130c53fb20": "O nome não pode conter caracteres ilegais e símbolos especiais/\\;:*?\"<>|%&amp;",
  "e832d41acc": "Guia de dois passos Saltar",
  "80d9cf7177": "Guia de dois passos Atualizar",
  "0aebf80435": "Guia de dois passos Clique no Rótulo",
  "e74f515977": "Guia de duas etapas handleSubmit",
  "308d2a53c9": "Guia de duas etapas createGroup",
  "dda2ed7e18": "Guia de dois passos Falha ao Criar Equipa",
  "ded3c35500": "Falha ao criar equipa",
  "4f18031bc1": "Guia de duas etapas createTemplate",
  "091e5cefcc": "Guia de dois passos Erro na Criação de Template",
  "58cf4e00f0": "Código de verificação",
  "92abbf0385": "Enviar Código de Verificação",
  "f0f9976ef9": "Por favor, insira o número de telefone",
  "a4ce99b1df": "Código de verificação",
  "39d36e0f9f": "Confirmar",
  "0fd8a01938": "Enviar",
  "9048a4e842": "Número de Telefone",
  "9afa1091eb": "Reenviar",
  "58d787001f": "Insira outro número de telefone para criar a escola",
  "450905a265": "Insira outro número de telefone para criar a empresa",
  "f7386de3c6": "Selecione no Desdobrável",
  "27aa05a92c": "Aceitar os Termos de Serviço",
  "80af61cb57": "Voltar para a Página Anterior",
  "50149b8d4f": "Nome do Solicitante",
  "e6756f8749": "Por favor, insira o seu nome",
  "3cbd51a2b1": "O nome deve ter pelo menos 2 caracteres, por favor insira um nome de 2 a 10 caracteres",
  "4f79b4813f": "O nome só suporta caracteres chineses, números, inglês, ·",
  "71d3e75983": "Número de Telefone Comum",
  "afe5149035": "Por favor, insira o seu número de telefone comum",
  "1e9270b50f": "Por favor, insira o seu número de telefone comum, 11 dígitos",
  "ff5dc98dfb": "Saltar",
  "165be2ab43": "Voltar para o Passo Anterior",
  "231d8a335a": "Aceitar os Termos de Serviço",
  "1cad008ffc": "O nome da empresa {0} já está registado, por favor use outro nome",
  "c6e274fcab": "Confirmação do Acordo",
  "b9352504bb": "Fechar Janela de Aceitação",
  "8409e99ad0": "Abrir Janela de Aceitação",
  "1593c6dd95": "Submeter",
  "4f44a9de22": "Abrir Verificação por SMS",
  "26b70c68b8": "Pular, ir diretamente para a empresa",
  "a8bebcb302": "Voltar para a Página Anterior",
  "c800b4fec5": "Página de Convite Base Montada",
  "38b396d5b0": "Página de Convite docsWeb Montada",
  "2eb7f9a9f1": "A sua reclamação foi submetida com sucesso",
  "2c6f3590fb": "Nós prevemos enviar o resultado do tratamento para o seu e-mail dentro de 3 dias úteis",
  "2ea3eff708": ", por favor verifique.",
  "53acfba22c": "Convidar Colegas Imediatamente",
  "4e6d282f4f": "Juntar-se ao Convite da Empresa",
  "5f72f4b936": "Convidar Colegas Imediatamente",
  "e5383077ba": "Recuperar Nome da Empresa",
  "06e3fa2350": "Após Consulta,",
  "653a263b5e": "O Criador É",
  "769f57269f": "O Número de Telefone do Criador É",
  "09a224695e": "Por favor, confirme se o criador da empresa é seu colega.",
  "3beda6c149": "·Se for o seu colega, pode contactá-lo",
  "5c74dd10d1": "Modificar o nome da empresa ou transferir o administrador principal.",
  "da504edb0f": "·Se não for o seu colega, pode clicar no botão abaixo para continuar a recuperar o nome da empresa.",
  "39194faaf1": "Continuar a recuperar o nome da empresa",
  "e22b829e90": "Copiado com sucesso",
  "6e1b44752a": "Valor TXT",
  "79881b1d7a": "Convidar colega agora",
  "a5344a45f9": "Clique no canto superior direito e selecione \"Enviar para amigo\".",
  "a4954a5b08": "Convidar colega agora",
  "8e3a1625fb": "Recuperar o nome da empresa",
  "bf8b8c7005": "Carregar licença de operação da empresa",
  "bfd44a66c9": "Clique para selecionar",
  "d503f20925": "Por favor, carregue o escaneamento ou foto da licença de operação da empresa.",
  "cbebe043c5": "Suporta formatos JPG, JPEG, PNG, BMP, PDF, tamanho não superior a 10 MB.",
  "9650b96d7d": "Carregar formulário de apelação de nome duplicado",
  "c3b8ae46d3": "Por favor, carregue o escaneamento ou foto do formulário de apelação de nome duplicado.",
  "9e325a9e09": "Baixar modelo de formulário",
  "a4711aae88": "Submeter aplicação",
  "3a5cc1441e": "Em processo de verificação...",
  "0bd7bf8511": "Atualmente não podemos verificar o seu domínio, você pode precisar esperar um pouco enquanto seu provedor de domínio atualiza suas informações. Se não houver resposta após um período, tente verificar novamente ou alterar o domínio.",
  "fae48d554b": "Verificando domínio",
  "5e1779a0ca": "registro de verificação, você pode fechar esta página e voltar mais tarde para verificar.",
  "ca85f8b836": "Bem-vindo à versão empresarial",
  "2570e0f00b": "Falha no início de sessão",
  "40d16a007e": "Sua conta pessoal foi vinculada automaticamente.",
  "81376b92e4": "modo de login de {0}, por favor, faça login novamente para mudar para a conta empresarial.",
  "ba679ba739": "Entendi, vou fazer login",
  "c05f64c6c6": "Após {0} vá para o login automaticamente.",
  "c329ccef3a": "Falha no início de sessão",
  "e370f9afb1": "Sua conta pessoal foi vinculada automaticamente.",
  "410cf42585": "modo de login de, por favor, faça login novamente para mudar para a conta empresarial.",
  "062d48aece": "Entendi, vou fazer login",
  "95a105d412": "Após vá para o login automaticamente.",
  "2d000d5a6d": "Envie o link de compartilhamento para os membros, que poderão pedir para se juntar após abrir.",
  "8861b6e90d": "Entrar na empresa",
  "25b9f72fda": "Erro de parâmetro de página",
  "1c76123efc": "Falha ao obter o link de convite",
  "6caba48b76": "Saltar",
  "f66379c650": "Erro de parâmetro de página",
  "c45021de2a": "Falha ao criar.",
  "011d470126": "A plataforma continua protegendo a segurança de suas informações",
  "f1a44d9151": "A plataforma recebeu os certificados ISO27001 e ISO27701 do BSI internacional, e passou na avaliação de segurança de nível três do governo.",
  "255ea5dff7": "Livro Branco de Segurança",
  "bb55b124f2": "Criar Apresentação Empresarial",
  "61e24974a3": "Criar Conteúdo de Estratégia de Aquisição Empresarial",
  "bfdf78febe": "Próximo Passo para Completar as Informações",
  "c4aa2d2d60": "Insira o Nome do Grupo de Trabalho ou do Projeto",
  "b69765ab64": "Equipas Que Todos Estão a Criar",
  "9657d9408b": "Substituir",
  "e21da8c16a": "seguinte",
  "224ef5cc9f": "Pular Introdução",
  "641f58c8f6": "A Empresa Atual Não Suporta Membros Criando Equipes, Por Favor Contate o Administrador",
  "efea622752": "Copiar Link, Convidar Colegas",
  "fd5b40a9fd": "Convidar Você a Se Juntar ao \"{0}\", Colaborar Juntos",
  "b04dd2f10a": "Link de Convite Copiado",
  "d1606a1b1a": "Falha ao Copiar, Tente Novamente",
  "0d59f3db83": "Insira o Departamento do Projeto ou Equipe, Como \"Departamento de Vendas\"",
  "9429513d34": "Não Precisa de Introdução",
  "b54a20b1ff": "Falha ao criar.",
  "093fa0fb74": "Autorizando Login...",
  "b383b136f4": "Iniciar Projeto Empresarial",
  "b6b21b388b": "Nome da Empresa Já Está em Uso",
  "285dc68c10": "Este Nome de Empresa Já Está em Uso:",
  "1bf685b89d": "Administrador:",
  "7b4297edcc": "Data de Registro:",
  "fa51ea19fc": "Recomendamos Tentar Encontrar ou Contatar o Colega Acima.",
  "e3678a996d": "Também Pode Usar Temporariamente Outro Nome para Criar a Empresa (Pode Mudar Depois) e Então Enviar uma Apelação.",
  "5969bc8071": "OK",
  "ba4cf699df": "Recuperar Nome da Empresa",
  "afecee4eb4": "Seu Nome",
  "a8bdebc614": "Por Favor Insira Seu Nome",
  "5bbeb38a66": "Telefone",
  "b4f7b44b7a": "Por Favor Insira Seu Número de Contato",
  "cac2913686": "Email de Contato",
  "23d3bb3a42": "Por Favor Insira Seu Email de Contato",
  "ea106a393c": "Carregar Licença Comercial da Empresa",
  "f74131d71e": "Clique para Escolher",
  "53749c51c5": "Por Favor Carregue a Licença Comercial da Empresa ou Foto",
  "c00f2ea171": "Suporta Formatos JPG, JPEG, PNG, BMP, PDF, Tamanho Não Excede 10 MB.",
  "57ec07fa97": "Carregar Formulário de Apelação por Nome Duplicado",
  "8eb0606e94": "Por Favor Carregue o Formulário de Apelação por Nome Duplicado ou Foto",
  "f59e76c0b0": "Baixar Modelo de Formulário",
  "030bd26fa4": "Enviar Pedido",
  "0a602dc727": "Armazenamento Seguro de Dados",
  "9138f28acf": "Colaboração por Partilha de Arquivos",
  "b3a306cf90": "Conformidade e Legalidade",
  "973c53f725": "Sugere-se Alterar o Nome, Após o Registro Pode Enviar Certificação da Instituição e Atualizar o Nome",
  "f886f5e92f": "Sugere-se Alterar o Nome, Após o Registro Pode Enviar Certificação Empresarial e Atualizar o Nome",
  "b8051702a3": "Este Nome Contém Palavras Sensíveis, Ajuste o Nome ou Entre em Contato com o Suporte",
  "d73881f7d4": "Nome da Empresa Protegido",
  "dc7e58e320": "Nome da Empresa Protegido, é Necessário Verificar a Informação Antes de Usar. Sugere-se Alterar o Nome da Empresa, Ou Usar o Nome Após Registro e Certificação Empresarial.",
  "20c3bc070c": "Confirmar",
  "c4278e5f28": "Permissão insuficiente",
  "9217efae21": "A conta com a qual está autenticado não possui permissão para criar. Por favor, contate o representante de vendas.",
  "52ff08f2ad": "Nome da instituição protegido, ajuste o nome da empresa.",
  "79386ae280": "Por favor, insira o código de verificação de 6 dígitos.",
  "d7b2c5a41b": "Código de verificação enviado para",
  "ce2e1c26f7": "(Válido por 10 minutos)",
  "59d338903f": "Pode solicitar novo código em {0} segundos.",
  "5aadd14136": "Reenviar código de verificação",
  "90f5c93432": "Este nome já está registrado.",
  "1677072f4a": "Pode adicionar mais informações ou registrar com outro nome.",
  "3b8459fb1e": "Preencher rapidamente:",
  "6f38edbcb1": "Registrar com este nome.",
  "8406c81e2d": "Filial",
  "29d323fa85": "Centro subsidiário",
  "4f0e806e02": "Departamento financeiro",
  "3f935efb6b": "Concordar com o contrato de serviço",
  "b42241be05": "Não agora",
  "99de4b33b7": "Concordo",
  "7f867e7395": "Criar empresa com outro número de telefone",
  "0d51a8f7a6": "Continuar criação",
  "8bdaecf2e5": "Por favor, insira o seu número de telefone.",
  "565ae60c8a": "Por favor, insira o seu nome.",
  "f76e06d0e7": "Por favor, insira o seu número de telefone.",
  "7b0fca5255": "Por favor, insira o código de verificação.",
  "68026d2d25": "Bem-vindo à versão empresarial.",
  "d25b5541be": "Criação gratuita.",
  "32cfd73733": "Por favor, insira o nome da equipe, empresa ou organização.",
  "4cf83dc4a0": "Criação rápida em um minuto, colabore eficientemente com colegas.",
  "d320d37116": "Criação gratuita da equipe/empresa.",
  "c54b475dd2": "Contrato do Usuário.",
  "190d54e616": "Empresa de {0}",
  "8c1b768ac4": "Falha na verificação inteligente.",
  "d74eab0f35": "O nome da empresa não está em conformidade com as normas da plataforma. Por favor, modifique e tente novamente.",
  "0f3d62dd4f": "O nome fornecido não está em conformidade com as normas da plataforma. Por favor, revise e tente novamente.",
  "647cf2211b": "O número de telefone atual não é suportado para criação, por favor, use outro.",
  "b63d96cdae": "As informações fornecidas não estão em conformidade com as normas da plataforma. Por favor, revise e tente novamente.",
  "2dbbe8e43f": "O número de telefone atual não é suportado para criação, por favor, modifique e tente novamente.",
  "b18abc5de6": "Sem número de telefone associado.",
  "f5233dae6f": "Por favor, use outro número de telefone para criar a empresa.",
  "4167c8b88d": "O número de telefone atual pode ter as seguintes situações, por favor, tente usar outro número de telefone para criar. Se houver dúvidas, contate o atendimento ao cliente.",
  "a8a2433c4d": "Escaneie o código QR do WeChat para adicionar e consultar o atendimento ao cliente.",
  "444a639c09": "Compreendi",
  "69a097057f": "O número de telefone atual pertence ao segmento de operadora virtual <#BB2726>",
  "4370b06fd0": "O número de telefone atual apresenta <#BB2726>comportamento de uso anômalo<#BB2726>",
  "8c49e1dc4a": "Verificação humana necessária",
  "4b8ba7d8cc": "Nova plataforma de produtividade da Kingsoft",
  "81be771e17": "🎉Empresa criada com sucesso! Complete as informações e obtenha serviços exclusivos",
  "461125b057": "Pode gerir documentos e informações dentro da equipa. Os membros da equipa podem visualizar facilmente, definir permissões de edição/descarga, garantindo a segurança dos dados.",
  "c3eb25029b": "Dimensão da empresa/equipa",
  "049f8401ec": "Menos de 5 pessoas",
  "c81896349e": "6-20 pessoas",
  "7357daac4e": "21-50 pessoas",
  "f0e65a0a29": "51-100 pessoas",
  "b9fac8204a": "101-200 pessoas",
  "62d73dddaf": "201-500 pessoas",
  "3bcdaf7160": "501-2000 pessoas",
  "ab0b2333fe": "Mais de 2000 pessoas",
  "4f756eedc8": "Qual é o seu papel",
  "3ba0b502c3": "Diretor Geral",
  "702099cc72": "Financeiras",
  "843b603162": "Compras",
  "8b414a9b44": "Pessoal/Administrativo",
  "92486b2908": "Vendas",
  "ac4e7fb063": "A sua organização tem orçamento/plano de aquisição de software",
  "37634c72dc": "Dentro de meio ano",
  "bd94b6deec": "Dentro de 1 ano",
  "713f4aad5c": "Em consideração",
  "c5ea095a4d": "Sem plano",
  "2409099a69": "<img src=\"https://ks3-wpsplus-prod.wpscdn.cn/e2546275-3953-40b4-8933-9ff6f0a1aeb4.png\"> Crie uma equipe, convide membros para colaborar",
  "9d27dc2d90": "Pode inserir o nome da sua equipa ou do projeto recentemente seguido",
  "de19c8509a": "Pode querer criar:",
  "1a84699223": "Departamento de Vendas",
  "efab59502b": "Departamento de Produtos",
  "7e599b3713": "Departamento de Operações do Sul",
  "bf494779c2": "Departamento de Compras",
  "f3a60ab34d": "Departamento Administrativo",
  "bbc50c1ac8": "Departamento de Finanças do Norte",
  "32629e3dac": "Departamento de Finanças de Produtos",
  "5524d354ba": "Departamento de TI",
  "0ccda29a0d": "🎁<span style='color: rgb(206,131,62);'>Você desbloqueou os benefícios para iniciantes!</span> Convide mais 3 pessoas para obter <span style='color: rgb(206,131,62);'>4T de espaço e benefícios do WPS AI</span>",
  "939eb98492": "<span style='color: rgb(206,131,62);'>Você desbloqueou limite de 50 pessoas e upload de arquivo único de 4G</span>. Continue convidando 3 pessoas para desbloquear 30 dias de WPS AI e benefícios de espaço de 4T",
  "136c26d941": "Copie o link abaixo, convide membros a juntarem-se",
  "3de5c12558": "Copie o link, convide colegas",
  "a5d64b14f3": "Guia de informações empresariais",
  "b8f2492701": "Recolha de informações empresariais",
  "1f9d053dc0": "Criar modelo de equipa",
  "0e83c79a88": "Convidar membros",
  "821fc1906a": "Entrar na empresa",
  "463e14ae9c": "Por favor, selecione uma equipa",
  "690f0cdb9e": "Ícone completo",
  "c340522a17": "Anterior",
  "f9355c72ef": "Saltar",
  "bd6c09ebbb": "seguinte",
  "2a2603cd3f": "Envie convite aos colegas por código QR",
  "411e64907a": "Copiar",
  "b0d988cf23": "Transferir",
  "e3c0b650ac": "Copiado com sucesso",
  "713ac624b4": "Bem-vindo ao WPS 365",
  "b8fff97849": "Elemento de alvo inválido",
  "02acdcf296": "Falha na conversão html2canvas, canvas não gerado",
  "a76988c496": "Falha na conversão de canvas para blob",
  "af89584edf": "API de transferência para a área de transferência não disponível",
  "f90263bbde": "Falha ao copiar imagem",
  "71b05319da": "Falha ao converter html para canvas",
  "38852999fe": "Falha ao guardar informações",
  "4a4c621d07": "Falha ao Criar Equipe, Por Favor Tente Novamente Mais Tarde",
  "d239a23994": "A Página Atual É Acessível Apenas Para Contas Empresariais, Por Favor Inicie Sessão Numa Conta Empresarial Primeiro.",
  "d93bfb7fb9": "Por favor, insira o conteúdo",
  "42b81a66c4": "Comprimento entre 2 e 100 caracteres",
  "76d33733db": "Não pode conter caracteres especiais como / \\ ; : * ? \" < > | % &",
  "dc55d1f62f": "Experimente",
  "b25233cba0": "Colaboração de documentos + comunicação instantânea, iniciando nova forma de trabalho eficiente",
  "f0e563652d": "<img src=\"https://vasvip-pub.wpscdn.cn/prod/SAAS-UG/atomic_guidance/icon/woa_logo_l.png\"> Inicie um chat em grupo colaborativo, compartilhamento de documentos seguro e conveniente",
  "1e484cce68": "<img src=\"https://vasvip-pub.wpscdn.cn/prod/SAAS-UG/atomic_guidance/icon/lingxi_normal.png\"> Assistente de IA Lingxi, um assistente inteligente criado para escritórios",
  "e338385bc9": "Inteligência Nativa do Office, profundamente integrada com AI e software de escritório, proporcionando assistência AI a todos",
  "7ae1f3b1c6": "Importação de Arquivo(s) Concluída, veja o resultado em 'Meus Documentos na Nuvem'",
  "85db2a024a": "Falha na Importação de Arquivo(s), por favor tente novamente mais tarde",
  "9ff74c802a": "Baixar Versão para Chip Intel",
  "ab44928f02": "Baixar Versão para Chip Apple",
  "a08d937c38": "Upload de Arquivo(s) em Andamento, veja em 'Meus Documentos na Nuvem' após concluído",
  "68db1829fa": "Suporta apenas importação de conta pessoal, por favor entre na sua conta pessoal para tentar novamente.",
  "1185a7c7ab": "Menos de 20 pessoas",
  "e2bcc252c9": "21-300 pessoas",
  "3c4842f1ea": "301-1000 pessoas",
  "1bbee64cfa": "Mais de 1000 pessoas",
  "388ff4a035": "Professor",
  "d341b1d794": "Aluno",
  "bfb2ee4148": "Mais",
  "f6450c3f31": "Gestão de Projetos",
  "b87fd33a0d": "Plano Anual",
  "0dd45a1c14": "Gestão de Desempenho de Funcionários",
  "67fa01cac6": "Atividades de Marketing",
  "6dd82cc031": "Recrutamento de Funcionários",
  "a7edaed91d": "Material Didático",
  "bf12b7efb0": "Gestão de Planos de Ensino",
  "c35ae8f358": "Documentação de Produtos",
  "343f236a78": "<img src=\"https://vasvip-pub.wpscdn.cn/prod/SAAS-UG/atomic_guidance/icon/dbsheet.png\"> Tabela Multidimensional WPS, construa sistema de negócio visual personalizado",
  "72286d5519": "👏Modelos Recomendados",
  "0bc00ee949": "Gestão de Defeitos de Requisitos",
  "e22f3d56f7": "Gestão de Criação de Conteúdo",
  "dd439de3dd": "Sistema de Gestão de Clientes",
  "fbb2bbf82e": "Plano de Estudos",
  "0645b908bc": "Consulta de Folha de Pagamento",
  "813b3d3d7e": "Gestão de OKR",
  "918e33d5bd": "Criar com Um Clique",
  "ebf9cfb7ef": "<img src=\"https://vasvip-pub.wpscdn.cn/prod/SAAS-UG/atomic_guidance/icon/import_files.png\"> Importe Documentos Comuns, Uso Mais Prático",
  "c58f28713c": "Importar Localmente",
  "9d6a0a4370": "Suporta Formatos de Arquivo Comuns do Office",
  "54c48aee85": "Selecionar ficheiro",
  "c5b593e452": "Importar da Conta Pessoal",
  "4bdcd9d4c5": "Importar Documentos, Equipes e Pastas da Conta Pessoal com Um Clique",
  "99b2968905": "Importar Autorização",
  "472f818a23": "<img src=\"https://vasvip-pub.wpscdn.cn/prod/SAAS-UG/atomic_guidance/icon/woa_logo_l.png\"> Baixar Cliente WPS Teams",
  "fe46574227": "Colaboração de documentos + comunicação instantânea, nova forma eficiente de trabalhar",
  "beefe5a09b": "Baixe agora mesmo",
  "278839c7b1": "<img src=\"https://vasvip-pub.wpscdn.cn/prod/SAAS-UG/atomic_guidance/icon/woa_logo_l.png\"> Configurações de segurança abrangentes, garantindo a segurança dos dados",
  "b4e70dbeab": "Anos de experiência da WPS em segurança de documentos, garantindo que dados críticos da empresa não vazem",
  "42dc772619": "Arquivo muito grande, recomendamos importar novamente mais tarde na página inicial",
  "a052564e47": "Erro de criação, por favor, tente novamente mais tarde",
  "790d0c428c": "Entrar na Bancada de Trabalho"
}